import { ref } from 'vue';
import { useWalletStore } from '../stores/wallet';
import { useChainStore } from '../stores/chain';

export type NftItem = {
  contractAddress: string;
  tokenId: string;
  name?: string;
  symbol?: string;
  image?: string;
  tokenUri?: string;
  metadata?: any;
};

export function useNfts() {
  const wallet = useWalletStore();
  const chain = useChainStore();
  const items = ref<NftItem[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);
  const cursor = ref<string | null>(null);
  const meta = ref<{ cached?: boolean; updatedAt?: string | null; nextRefreshAt?: string | null; cooldownSecondsRemaining?: number } | null>(null);

  async function load(reset = true, forceRefresh = false) {
    if (!wallet.address) {
      items.value = [];
      error.value = null;
      return;
    }
    if (reset) cursor.value = null;
    loading.value = true;
    try {
      const url = new URL(`/api/nfts`, window.location.origin);
      url.searchParams.set('address', wallet.address);
      url.searchParams.set('chainId', String(chain.current.id));
      if (cursor.value) url.searchParams.set('cursor', cursor.value);
      if (forceRefresh) url.searchParams.set('refresh', '1');
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error('Failed to load NFTs');
      const json = await res.json();
      if (reset) items.value = [];
      items.value = [...items.value, ...(json.nfts || [])];
      cursor.value = json.cursor || null;
      meta.value = json.meta || null;
      error.value = null;
    } catch (e: any) {
      error.value = e?.message || 'Failed to load NFTs';
    } finally {
      loading.value = false;
    }
  }

  return { items, loading, error, load, meta };
}
